import React, { useState } from 'react';
import { Content, Row, Col, Title, Text, Button } from 'components';
import { SideMenu } from '../components';
import { Input, Spin } from 'antd';

const MypageCouponPresenter = (props) => {
  /* ===== Props ===== */
  const {
    coupons,
    tabItem,
    activeTab,
    isLoading,
    inputValue,
    onRegister,
    onTabChange,
    onChange,
    screenSize,
  } = props;

  /* ===== Variables ===== */
  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 25,
    },
    title: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
      fontWeight: 700,
      color: 'var(--black-color)',
      fontFamily: 'Pretendard',
    },
    tabs: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid var(--light-gray-color)',
      marginBottom: screenSize >= 768 ? 80 : 40,
    },
    tab: (isActive) => ({
      width: '50%',
      textAlign: 'center',
      padding: '16px 0',
      fontWeight: isActive ? 'bold' : 'normal',
      fontSize: screenSize >= 768 ? 16 : 14,
      color: isActive ? 'var(--black-color)' : 'var(--gray-color)',
      borderBottom: isActive
        ? '2px solid var(--black-color)'
        : '1px solid var(--gray-color)',
      cursor: 'pointer',
    }),
    couponLayout: {
      width: screenSize >= 768 ? '48%' : '100%',
      height: screenSize >= 768 ? 192 : screenSize >= 500 ? 170 : 150,
      backgroundColor: '#f4f4f4',
      borderLeft: '20px solid #ddd',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 40,
      paddingLeft: 20,
    },
    couponTitle: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 24 : 18,
      fontWeight: 700,
      marginBottom: 16,
    },
    couponStatus: {
      color: 'var(--black-color)',
      fontSize: screenSize >= 768 ? 16 : screenSize >= 500 ? 15 : 14,
      lineHeight: 1.75,
    },
    couponDate: {
      fontSize: screenSize >= 500 ? 14 : 13,
      fontWeight: 700,
      color: 'var(--dark-gray-color)',
    },
  };

  /* ===== Props ===== */

  /* ===== State ===== */

  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '120px 0px 200px' : '60px 0'}
        >
          <Row gutter={25} /*  style={{ marginTop: 120 }} */>
            <Col x={0} md={1} xl={2}></Col>
            <Col x={0} md={6} xl={4}>
              <SideMenu />
            </Col>
            <Col x={24} md={16} xl={16}>
              <Content
                maxWidth={'100%'}
                padding={
                  screenSize >= 1200
                    ? '0 0 0 95px'
                    : screenSize >= 768
                    ? '0 0 0 20px'
                    : '0'
                }
              >
                {/* 쿠폰 섹션 */}
                <div
                  style={{
                    ...styles.titleLayout,
                  }}
                >
                  <Title style={{ ...styles.title }}>쿠폰</Title>
                </div>
                {/* 쿠폰입력 / 쿠폰입력 창 / 쿠폰등록버튼 */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: screenSize >= 768 ? 80 : 40,
                  }}
                >
                  <div
                    style={{
                      backgroundColor: '#f4f4f4',
                      padding: screenSize >= 768 ? '32px 40px' : 20,
                      display: 'flex',
                      justifyContent: 'space-between',
                      color: 'var(--black-color)',
                      borderRadius: 4,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        gap: screenSize >= 768 ? 24 : 10,
                        width: screenSize >= 768 ? '75%' : '65%',
                      }}
                    >
                      <span
                        style={{
                          fontSize: screenSize >= 768 ? 18 : 15,
                          fontWeight: 700,
                          display: screenSize >= 768 ? 'unset' : 'none',
                        }}
                      >
                        쿠폰입력
                      </span>
                      <div
                        style={{ width: screenSize >= 768 ? '70%' : '100%' }}
                      >
                        <Input
                          value={inputValue}
                          placeholder={screenSize >= 768 ? '' : '쿠폰입력'}
                          onChange={(e) => onChange(e.target.value)}
                          style={{
                            fontSize: screenSize >= 768 ? 18 : 15,
                            width: '100%',
                            height: screenSize >= 768 ? 48 : 40,
                          }}
                        />
                      </div>
                    </div>
                    <Button
                      style={{
                        fontSize: screenSize >= 900 ? 16 : 13,
                        fontWeight: 700,
                        width: screenSize >= 768 ? '23%' : '30%',
                        height: screenSize >= 768 ? 48 : 'atuo',
                        borderRadius: 4,
                        padding: screenSize >= 768 ? 'auto' : '4px 10px',
                      }}
                      onClick={() => onRegister()}
                    >
                      쿠폰 등록
                    </Button>
                  </div>
                </div>

                <div>
                  {/* 쿠폰 탭 */}
                  <div style={styles.tabs}>
                    {tabItem.map((tap) => (
                      <div
                        key={`tap-${tap.value}`}
                        style={styles.tab(activeTab === tap.value)}
                        onClick={() => onTabChange(tap.value)}
                      >
                        {tap.label}
                      </div>
                    ))}
                  </div>

                  {/* 쿠폰 리스트 */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      rowGap: screenSize >= 768 ? 80 : 20,
                    }}
                  >
                    {coupons[activeTab].length ? (
                      coupons[activeTab].map((coupon, index) => (
                        <div key={index} style={styles.couponLayout}>
                          <div style={styles.couponTitle}>{coupon.title}</div>
                          <div style={styles.couponStatus}>
                            {coupon.content}
                          </div>
                          <div style={styles.couponDate}>
                            사용기한 : {coupon.expiry_date}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div
                        style={{
                          padding: '20px',
                          textAlign: 'center',
                          width: '100%',
                        }}
                      >
                        해당 탭에 쿠폰이 없습니다.
                      </div>
                    )}
                  </div>
                </div>
              </Content>
            </Col>
            <Col x={0} md={1} xl={2}></Col>
          </Row>
        </Content>
      </Spin>
    </React.Fragment>
  );
};

export default MypageCouponPresenter;
